import type { AiModelProfileDto } from "@/api/types";
import type { TranslationFunction } from "@/translations";

export type CopilotProfileOption = {
  value: AiModelProfileDto;
  /** Whether selecting this profile requires elevated platform access. */
  restrictedToSuperAdmins: boolean;
};

/** The profiles available in the Copilot prompt configuration selector. */
export const copilotProfileOptions: CopilotProfileOption[] = [
  { value: "efficient", restrictedToSuperAdmins: false },
  { value: "thorough", restrictedToSuperAdmins: false },
  { value: "balanced", restrictedToSuperAdmins: true },
  { value: "advanced", restrictedToSuperAdmins: true },
];

export function getCopilotPromptTypeName(t: TranslationFunction, type: "community" | "ticket"): string {
  return t(
    type === "community"
      ? "page.integration.copilot-configurations.prompt-type.community"
      : "page.integration.copilot-configurations.prompt-type.ticket",
  );
}

export function getCopilotProfileName(t: TranslationFunction, profile: AiModelProfileDto): string {
  return t(`page.integration.copilot-configurations.profile.${profile}`);
}

export function getCopilotProfileDescription(t: TranslationFunction, profile: AiModelProfileDto): string {
  return t(`page.integration.copilot-configurations.profile.${profile}.description`);
}
